import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { AreaTools } from 'models/editor'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'
import { useFetchOrganization } from 'services/organization'

export const CustomReportTool: FC = () => {
  const { t } = useTranslation()
  const [{ areaTool }, mapEditorDispatch] = useMapEditorContext()
  const { organization } = useFetchOrganization()

  return (
    <button
      data-selected={areaTool === AreaTools.CUSTOM_REPORT_TOOL ? true : undefined}
      onClick={() => {
        mapEditorDispatch.selectTool(AreaTools.CUSTOM_REPORT_TOOL)
        mapEditorDispatch.setWizard(MapEditorWizards.CUSTOM_REPORT_TOOL)
        if (organization?.id === 38 || organization?.id === 39 || organization?.id === 37) {
          mapEditorDispatch.setConfirm(true)
        }
      }}
      aria-label={t('map.tools.custom_report')}
    >
      <Tooltip label={t(`tooltips.maptools.custom_report`)} direction="LEFT_CENTER">
        <Icon name="markup-line" />
      </Tooltip>
    </button>
  )
}

CustomReportTool.displayName = 'CustomReportTool'
